import {Component} from '@angular/core';

@Component({
  selector: 'app-platform-migration-maintenance',
  standalone: true,
  imports: [],
  templateUrl: './platform-migration-maintenance.component.html',
  styleUrl: '../maintenance/maintenance.component.scss',
})
export class PlatformMigrationMaintenanceComponent {}
